import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "leftEnhancer", "rightEnhancer", "leftAdornment", "rightAdornment", "children", "cursor", "size", "width", "minWidth", "maxWidth", "focused"];
import * as React from 'react';
import cx from 'classnames';
import { mergeStyles } from '../../utils';
import { useInputSize, InputSizeContext } from '../../hooks';
import { InputAdornment } from '../../../inputAdornment';
import { Spinner } from '../../../loader';
import inputGroupStyles from '../../../internal/styles/inputWrapperGroup.css';
import inputAdornmentStyles from '../../../internal/styles/inputWrapperAdornment.css';
import { getStyles } from './styles';
export var InputWrapper = /*#__PURE__*/React.forwardRef(function InputWrapper(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    leftEnhancer = props.leftEnhancer,
    rightEnhancer = props.rightEnhancer,
    leftAdornment = props.leftAdornment,
    rightAdornment = props.rightAdornment,
    children = props.children,
    cursor = props.cursor,
    sizeProp = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    focused = props.focused,
    rest = _objectWithoutProperties(props, _excluded);
  var size = useInputSize(sizeProp);
  var styles = mergeStyles(getStyles(size), inputGroupStyles, inputAdornmentStyles);
  var leftAdornmentContent = leftAdornment ? leftAdornment : leftEnhancer ? /*#__PURE__*/React.createElement(InputAdornment, null, leftEnhancer) : null;
  var rightAdornmentContent = loading ? /*#__PURE__*/React.createElement(InputAdornment, null, /*#__PURE__*/React.createElement(Spinner, {
    color: "gray_icons_100",
    size: 16
  })) : rightAdornment ? rightAdornment : rightEnhancer ? /*#__PURE__*/React.createElement(InputAdornment, null, rightEnhancer) : null;
  return /*#__PURE__*/React.createElement(InputSizeContext.Provider, {
    value: size
  }, /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: cx(styles['input-wrapper'], focused && styles['focused'], invalid && styles['invalid'], disabled && styles['disabled'], inline && styles['inline'], props.className),
    style: {
      cursor: cursor,
      width: width,
      minWidth: minWidth,
      maxWidth: maxWidth
    },
    tabIndex: disabled ? -1 : props.tabIndex
  }), leftAdornmentContent && /*#__PURE__*/React.createElement("span", {
    className: styles['left-adornment']
  }, leftAdornmentContent), /*#__PURE__*/React.createElement("div", {
    className: styles['children-wrapper']
  }, children), rightAdornmentContent && /*#__PURE__*/React.createElement("span", {
    className: styles['right-adornment']
  }, rightAdornmentContent)));
});